"use client";

import { useSessionStore } from "@/app/store/use-session-store";
import {
  AddressPoint,
  useAddressStore,
} from "@/entities/address/model/use-address-store";
import { usePlatformStore } from "@/entities/platform";
import { useDisclosure } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import {
  createPointFromCoordinates,
  findActivePoint,
  getUserLocation,
  shouldCreateNewPoint,
} from "./lib";
import Mobile from "./mobile";

function AutoGeolocate() {
  const [geoloc, setGeoloc] = useState<[number, number]>([0, 0]);
  const [initalPoint, setInitalPoint] = useState<AddressPoint | null>(null);
  const { open, setOpen } = useDisclosure();

  const points = useAddressStore((store) => store.points);
  const geolocation = useSessionStore((store) => store.geolocation);
  const rejectGeoL = useSessionStore((store) => store.rejectGeoL);
  const activePoint = useMemo(() => {
    return initalPoint || findActivePoint(points);
  }, [points, initalPoint]);

  const { params: platformParams } = usePlatformStore();
  const { isInitialized } = usePlatformStore();
  const porteLat = platformParams.lat ? Number(platformParams.lat) : 0;
  const porteLong = platformParams.long ? Number(platformParams.long) : 0;
  const isPorteEntry = Boolean(porteLat && porteLong && isInitialized);
  const addPoint = useAddressStore((state) => state.addPoint);
  const acceptGeoL = useSessionStore((state) => state.acceptGeoL);

  useEffect(() => {
    if (isPorteEntry) {
      setOpen(false);
      setGeoloc([porteLat, porteLong]);
      return;
    }

    if (geolocation === "accepted" && activePoint?.address) return;

    const timer = setTimeout(() => {
      if (geolocation !== "rejected") getGeolocation();
      setOpen(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, [activePoint?.address, isPorteEntry]);

  const getGeolocation = () => {
    if (geolocation !== "rejected") {
      getUserLocation()
        .then((location) => {
          if (location?.latitude) {
            const coords: [number, number] = [
              location.latitude,
              location.longitude,
            ];
            setGeoloc(coords);
          } else {
            rejectGeoL();
            console.warn("Geolocation success but no data");
          }
        })
        .catch((err) => {
          console.log("Failed to get location:", err);
          rejectGeoL();
        });
    }
  };

  useEffect(() => {
    if (shouldCreateNewPoint(geoloc, points, activePoint)) {
      createPointFromCoordinates(geoloc).then((newPoint) => {
        if (!newPoint) return;

        setInitalPoint(newPoint);

        if (isPorteEntry) {
          acceptGeoL();
          addPoint(newPoint);
          setOpen(false);
        }
      });
    }
  }, [geoloc, points, activePoint]);

  // UI pending design; return placeholder for now
  return (
    <Mobile
      open={open}
      activePoint={activePoint}
      onClose={() => setOpen(false)}
    />
  );
}

export default AutoGeolocate;
